import { automotiveCdpConfig } from "./automotive";
import { consumeSubscriptionsCdpConfig } from "./consumer-subscriptions";
import { d2cCdpConfig } from "./d2c";
import { educationCdpConfig } from "./education";
import { financialServicesCdpConfig } from "./financial-services";
import { healthcareCdpConfig } from "./healthcare";
import { insuranceCdpConfig } from "./insurance";
import { mediaEntertainmentCdpConfig } from "./media-entertainment";
import { qsrCdpConfig } from "./qsr";
import { retailCdpConfig } from "./retail";
import { type CdpIndustryConfig } from "./shared";
import { technologyB2bSaasCdpConfig } from "./technology-b2b-saas";
import { telecommunicationsCdpConfig } from "./telecommunications";
import { travelHospitalityCdpConfig } from "./travel-hospitality";
import { utilitiesEnergyCdpConfig } from "./utilities-energy";

export type CdpIndustrySlug =
  | "retail"
  | "financial-services"
  | "healthcare"
  | "technology-b2b-saas"
  | "d2c"
  | "media-entertainment"
  | "travel-hospitality"
  | "automotive"
  | "education"
  | "qsr"
  | "telecommunications"
  | "utilities-energy"
  | "insurance"
  | "consumer-subscriptions";

export const cdpIndustryVariants: Record<CdpIndustrySlug, CdpIndustryConfig> = {
  retail: retailCdpConfig,
  "financial-services": financialServicesCdpConfig,
  "technology-b2b-saas": technologyB2bSaasCdpConfig,
  healthcare: healthcareCdpConfig,
  d2c: d2cCdpConfig,
  "media-entertainment": mediaEntertainmentCdpConfig,
  "travel-hospitality": travelHospitalityCdpConfig,
  automotive: automotiveCdpConfig,
  insurance: insuranceCdpConfig,
  "utilities-energy": utilitiesEnergyCdpConfig,
  education: educationCdpConfig,
  telecommunications: telecommunicationsCdpConfig,
  qsr: qsrCdpConfig,
  "consumer-subscriptions": consumeSubscriptionsCdpConfig,
};

export * from "./shared";
